import { HuespedViewWrapper } from './Layout/Container/ContainerHoteleria/Views/HuespedViewWrapper'
import { TableGuestsWrapper } from '../features/guests/components/Tables/TableGuests'
import { FormGuest } from '../features/guests/components/Forms/FormGuest'
import { TableBathRoomsWrapper } from '../features/bathrooms/components/Tables/TableBathroom'
import { FormEditBed } from '../features/bed/components/Forms/FormEditBed'
import { FormNewBeds } from '../features/bed/components/Forms/FormNewBed'
import { TableBedsWrapper } from '../features/bed/components/Tables/TableBeds'
import { TableBookingsWrapper } from '../features/bookings/components/Tables/TableBookings'
import { FormModule, FormNewModule } from '../features/modules/components/Forms'
import { FormEditModuleWrapper } from '../features/modules/components/Forms/FormEditModule'
import { FormEditBedWrapper } from '../features/bed/components/Forms/FormEditModule'
import { TableModulesWrapper } from '../features/modules/components/Tables/TableModules'
import { FormEditRoomWrapper } from '../features/room/components/Forms/FormEditRoom'
import { FormNewRoom } from '../features/room/components/Forms/FormNewRoom'
import { TableRoomsWrapper } from '../features/room/components/Tables/TableRooms'
import { ModuleViewWrapper } from './Layout/Container/ContainerHoteleria/Views/ModuleViewWrapper'
import { HabitacionViewWrapper } from './Layout/Container/ContainerHoteleria/Views/HabitacionViewWrapper'
import { CamaViewWrapper } from './Layout/Container/ContainerHoteleria/Views/CamaViewWrapper'
import { FormRoom } from '../features/room/components/Forms/FormRoom'
import { FormBooking } from '../features/bookings/components/Forms/FormBooking'
import { TableCheckingWrapper } from '../features/checking/components/Tables/TableCheking'
import { TableChekinProductsWrapper } from '../features/checking/components/Tables/TableChekinProducts'
import { TableCheckoutWrapper } from '../features/checkout/components/Tables/TableChekout'
import { TableUploadBookingDetailsWrapper } from '../features/bookings/components/Tables/TableUploadBookingDetails'
import { TableUploadBookingSummaryDetailsWrapper } from '../features/bookings/components/Tables/TableUploadBookingSummaryDetails'
import { GuestDetailWrapper } from '../features/guests/components/Panel/GuestDetail'
import { DetailBookingPanel } from '../features/bookings/components/Panels/DetailBookingPanel'
import { HeaderAvailabilityPanel } from '../features/availability/panels/HeaderAvailabilityPanel'
import StartPageWrapper from './Views/StartPageWrapper'
import { HeaderBookingPanel } from '../features/bookings/components/Panels/HeaderBookingPanel'
import { HeaderChangeRoomsPanel } from '../features/change-rooms/panels/HeaderChangeRoomsPanel'
import { DetailChangeRoomsPanel } from '../features/change-rooms/panels/DetailChangeRoomsPanel'
import { HeaderGuestPanel } from '../features/guests/components/Panel/HeaderGuestPanel'

import { CheckInListPage } from '../features/checkInList/page/CheckInListPage'
import { TableCheckOutListWrapper } from '../features/checkOutList/component/CheckOut'
import { TableBookingIntegrationWrapper } from '../features/booking-integration/page'
import { HeaderGuestListPanel } from '../features/guestsList/components/Panel/HeaderGuestListPanel'
import { DetailGuestListPanel } from '../features/guestsList/components/Panel/DetailGuestListPanel'
import { TableHistoryGuestWrapper } from '../features/guests/components/Tables/TableHistoryGuest'
import { TableCheckInSummaryWrapper } from '../features/checking/components/Tables/TableCheckinSummary'
import { TableCheckOutSummaryWrapper } from '../features/checkout/components/Tables/TableCheckoutSummary'
import { TableCheckOutProductsWrapper } from '../features/checkout/components/Tables/TableCheckoutProducts'
import { TableReportFacturationWrapper } from '../features/reports/components/Tables/TableReportFacturation'
import { HeaderCheckInAutoPanel } from '../features/checkinUser/panels/HeaderCheckinAutoPanel'
import { TableReportFacturationSubWrapper } from '../features/reports/components/Tables/TableReportFacturationSub'
import { DetailReportSubPanel } from '../features/reports/components/Panels/DetailReportSubPanel'
import { HeaderCheckInParqueoPanel } from '../features/checkinUser/panels/HeaderCheckinParqueoPanel'
import { DetailTyCPanel } from '../features/tyc/panels/DetailTyCPanel'
import { FormTerms } from '../features/tyc/components/forms/FormTerms'
import { HeaderTyCPanel } from '../features/tyc/panels/HeaderTycPanel'
import { HeaderControlStatusPanel } from '../features/control-status/components/panels/HeaderControlStatusPanel'
import { HeaderBookingAppPanel } from '../features/app-huesped/panels/HeaderBookingAppPanel'
import { HeaderCheckinAppPanel } from '../features/app-huesped/panels/HeaderCheckinAppPanel'
import { HeaderCheckoutAppPanel } from '../features/app-huesped/panels/HeaderCheckoutAppPanel'
import { RatiosCheckInOut } from '../features/reports/components/RatiosCheckInOut'
import { RatiosRoomingList } from '../features/reports/components/RatiosRoomingList'
import { RatiosSalesDetail } from '../features/reports/components/RatiosSalesDetail'
import { RatioSalesSummary } from '../features/reports/components/RatiosSalesSummary'
import { HeaderRatioOccupancyPanel } from '../features/reports/components/Panels/HeaderRatioOccupancyPanel'
import { HeaderRatioAvailabilityPanel } from '../features/reports/components/Panels/HeaderRatioAvailabilityPanel'
import { HeaderRatioSummaryStayPanel } from '../features/reports/components/Panels/HeaderRatioSummaryStayPanel'
import { HeaderCancellationsPanel } from '../features/cancellations-changes/panels/HeaderCancellationsPanel'
import { HeaderReportOccupancyPanel } from '../features/reports/components/Panels/HeaderReportOccupabilityPanel'
import { HeaderReportValorationPanel } from '../features/valuation/components/Panels/HeaderPanel'
import { HeaderCheckInAutoAutoPanel } from '../features/checkinUser/panels/HeaderCheckinAutoAuto'
import { FormBookingftf } from '../features/booking-face-to-face/components/Forms/FormBookingftf'
import { TableUploadCheckinPrintingDetailsWrapper } from '../features/bookings/components/Tables/TableUploadCheckinPrintingDetails'
import { HeaderRetiredGuestsPanel } from '../features/retired-guests/panels/HeaderRetiredGuestsPanel'
import { ReportCamasPreferentes } from '../features/reports/components/ReportCamasPreferentes'
export const ListComponentsHoteleria = {
  'table-hosting-history': <TableHistoryGuestWrapper />,
  'table-checkin': <TableCheckingWrapper />,
  'table-checkin-table': <TableChekinProductsWrapper />,
  'table-checkout-table': <TableCheckOutProductsWrapper />,
  'table-checkout': <TableCheckoutWrapper />,
  'table-bookings': <TableBookingsWrapper />,
  'form-new-module': <FormNewModule />,
  'table-modules': <TableModulesWrapper />,
  'form-edit-module': <FormEditModuleWrapper />,
  'form-new-room': <FormNewRoom />,
  'table-rooms': <TableRoomsWrapper />,
  'form-edit-room': <FormEditRoomWrapper />,
  'table-beds': <TableBedsWrapper />,
  'table-bathrooms': <TableBathRoomsWrapper />,
  'form-new-bed': <FormNewBeds />,
  'form-edit-bed': <FormEditBed />,
  'form-module': <FormModule />,
  'form-room': <FormRoom />,
  'form-bed': <FormEditBedWrapper />,
  'table-guests': <TableGuestsWrapper />,
  'form-guest': <FormGuest />,
  'header-guests': <HeaderGuestPanel />,
  'guest-detail': <GuestDetailWrapper />,
  'form-bookings': <FormBooking />,
  'header-bookings': <HeaderBookingPanel />,
  'detail-bookings': <DetailBookingPanel />,
  'table-details-upload-booking': <TableUploadBookingDetailsWrapper />,
  'table-details-upload-booking-summary': <TableUploadBookingSummaryDetailsWrapper />,
  'table-details-upload-checkin-printing': <TableUploadCheckinPrintingDetailsWrapper />,
  'table-checkin-summary': <TableCheckInSummaryWrapper />,
  'table-checkout-summary': <TableCheckOutSummaryWrapper />,
  'header-availability': <HeaderAvailabilityPanel />,
  'header-change-rooms': <HeaderChangeRoomsPanel />,
  'detail-change-rooms': <DetailChangeRoomsPanel />,
  'table-checkIn-list': <CheckInListPage />,
  'table-checkOut-list': <TableCheckOutListWrapper />,
  'header-guest-list': <HeaderGuestListPanel />,
  'detail-guest-list': <DetailGuestListPanel />,
  'header-booking-integration': <TableBookingIntegrationWrapper />,
  'table-reportes': <TableReportFacturationWrapper />,
  'header-checkin-autoservicio': <HeaderCheckInAutoPanel />,
  'header-checkin-autoservicio-automatico': <HeaderCheckInAutoAutoPanel />,
  'header-checkin-parqueo': <HeaderCheckInParqueoPanel />,
  'table-reportes-sub': <TableReportFacturationSubWrapper />,
  'detail-report-sub': <DetailReportSubPanel />,
  'form-tyc': <FormTerms />,
  'header-tyc': <HeaderTyCPanel />,
  'detail-tyc': <DetailTyCPanel />,
  'header-control-status': <HeaderControlStatusPanel />,
  'header-reservas-app-huesped': <HeaderBookingAppPanel />,
  'header-checkin-app-huesped': <HeaderCheckinAppPanel />,
  'header-checkout-app-huesped': <HeaderCheckoutAppPanel />,
  'reportes-ratios-checkin-checkout': <RatiosCheckInOut />,
  'reportes-ratios-rooming-list': <RatiosRoomingList />,
  'reportes-ratios-resumen-ventas': <RatioSalesSummary />,
  'reportes-ratios-detalle-ventas': <RatiosSalesDetail />,
  'reportes-ratios-ocupabilidad': <HeaderRatioOccupancyPanel />,
  'reportes-ratios-disponibilidad': <HeaderRatioAvailabilityPanel />,
  'reportes-ratios-estadia': <HeaderRatioSummaryStayPanel />,
  'reportes-ocupabilidad': <HeaderReportOccupancyPanel />,
  'header-anulaciones-cambios': <HeaderCancellationsPanel />,
  'header-report-valoration': <HeaderReportValorationPanel />,
  'form-booking-face-to-face': <FormBookingftf />,
  'header-retired-guests': <HeaderRetiredGuestsPanel />,
  'reportes-camas-preferentes': <ReportCamasPreferentes />,
} as any

export const ListViewsHoteleria = {
  modules: <ModuleViewWrapper />,
  rooms: <HabitacionViewWrapper />,
  beds: <CamaViewWrapper />,
  guests: <HuespedViewWrapper />,
  start: <StartPageWrapper />,
} as any

export const renderPanelContent = (key: string | undefined) => {
  let component = <></>
  if (key) {
    component = ListComponentsHoteleria[key]
  }
  return component
}
